import { MachineTimesOptimizationMetadata, ProcessStep } from "../types";

type OptimizationWithLines<Line extends { processSteps: ProcessStep[] }> = {
  machineTimesOptimizationMetadata: Pick<
    MachineTimesOptimizationMetadata,
    "companyMachineId"
  > | null;
  quoteRequestLines: Line[];
};

export const getOptimizationMachineProcessSteps = <Line extends { processSteps: ProcessStep[] }>(
  optimization: OptimizationWithLines<Line>,
): { line: Line; step: Line["processSteps"][number] }[] => {
  const companyMachineId = optimization.machineTimesOptimizationMetadata?.companyMachineId;
  if (!companyMachineId) {
    return [];
  }

  return optimization.quoteRequestLines.flatMap((line) =>
    line.processSteps
      .filter((step) => step.companyMachineId === companyMachineId)
      .sort((left, right) => left.index - right.index)
      .map((step) => ({ line, step })),
  );
};
